import { Subscription } from 'rxjs';
import { Optional } from './../../common/utils/optional';
import { JOBADVERTISEMENT_SEARCH_CONFIG_BASE_PATH, SEARCH_CONFIG_JOBADVERTISEMENT } from 'app/rm/erp/common/model/searchConstants';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JobAdvertisement } from 'app/rm/erp/jobadvertisement/model/jobadvertisement';
import { JobAdvertisementService } from 'app/rm/erp/jobadvertisement/service/jobadvertisement.service';
import { HisNavigationService, HisBaseGlobalsService, DdEntryMerged } from 'hisng';

@Component( {
    selector: 'erp-jobadvertisement-detail-view',
    templateUrl: './jobadvertisement-detail-view.component.html',
} )
export class JobAdvertisementDetailViewComponent implements OnInit {
    jobad: JobAdvertisement = new JobAdvertisement();

    private jobAdvertisementIdSubscription?: Subscription;
    private checkJobApplicationPossibleSubsription?: Subscription;
    isRefNumberVisible = true;
    isValidToVisible = true;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly jobAdvertisementService: JobAdvertisementService,
        private readonly navigationService: HisNavigationService,
        private readonly hisBaseGlobalsService: HisBaseGlobalsService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe( paramMap => {
            Optional.ofNullable( paramMap )
                .map( ( m ) => m.get( 'id' ) )
                .map( ( id ) => parseInt( id, 10 ) )
                .ifPresent( ( id ) => {
                    this.subscribeToIdService( id );
                    this.subscribeToJobApplicationPossibleService( id );
                } );
        } );

        let ddRefNumber: DdEntryMerged = this.hisBaseGlobalsService.getDd('rm.erp.jobadvertisement.detailview.refNumber');
        this.isRefNumberVisible = this.isVisible(ddRefNumber);

        let ddValidTo: DdEntryMerged = this.hisBaseGlobalsService.getDd('rm.erp.jobadvertisement.detailview.validTo');
        this.isValidToVisible = this.isVisible(ddValidTo);
    }

    openJobApplication() {
        this.router.navigate( [`/jobapplication/create/jobapplication/${this.jobad.id}`] );
    }

    downloadJobAdvertisementDocument( jobAdvertisementId: number ) {
        this.jobAdvertisementService.downloadJobAdvertisementDocument( jobAdvertisementId );
    }

    private isVisible(ddEntry: DdEntryMerged): boolean {
        if ( ddEntry && ddEntry.hidden ) {
            return false;
        }
        return true;
    }

    private subscribeToIdService( id: number ): void {
        if ( this.jobAdvertisementIdSubscription ) {
            this.jobAdvertisementIdSubscription.unsubscribe();
        }
        this.jobAdvertisementIdSubscription = this.jobAdvertisementService.getById( id ).subscribe( ad => this.jobad = ad );
    }

    private subscribeToJobApplicationPossibleService( id: number ): void {
        if ( this.checkJobApplicationPossibleSubsription ) {
            this.checkJobApplicationPossibleSubsription.unsubscribe();
        }
        this.checkJobApplicationPossibleSubsription = this.jobAdvertisementService.checkJobApplicationPossible( id )
            .subscribe({
                next: ( () => { } ),
                error: () => {
                    const searchResultURL = JOBADVERTISEMENT_SEARCH_CONFIG_BASE_PATH + SEARCH_CONFIG_JOBADVERTISEMENT;
                    this.navigationService.setSearchResultUrl( searchResultURL );
                    this.navigationService.navigateToLastSearchResultUrl();
                } });
    }
}
